import { useCallback, useEffect, useMemo, useState } from 'react';
import { useGetMyAddedStockLogsQuery } from '../../../../api/endpoints/dealerStockAdd';
import { formatDateForApi } from '../../../../utils/dateUtils';

const getThreeMonthsAgo = () => {
    const date = new Date();
    date.setMonth(date.getMonth() - 3);
    return date;
};

const getToday = () => new Date();

const useDealerStockAddData = () => {
    const [rows, setRows] = useState([]);
    const [totalCount, setTotalCount] = useState(0);
    const [pagination, setPagination] = useState({ PageNumber: 1, PageSize: 10 });

    const [filters, setFilters] = useState({
        startDate: getThreeMonthsAgo(),
        endDate: getToday()
    });

    const queryParams = useMemo(() => ({
        PageNumber: pagination.PageNumber,
        PageSize: pagination.PageSize,
        DateFrom: formatDateForApi(filters.startDate),
        DateTo: formatDateForApi(filters.endDate)
    }), [pagination, filters]);

    const { data: listData, isLoading, isFetching, refetch } = useGetMyAddedStockLogsQuery(queryParams, {
        refetchOnMountOrArgChange: true
    });

    useEffect(() => {
        if (listData) {
            setRows(Array.isArray(listData.items) ? listData.items : []);
            setTotalCount(listData.totalCount || 0);
        }
    }, [listData]);

    const loading = isLoading || isFetching;

    const onPageChange = useCallback((event) => {
        const newPageNumber = Math.floor(event.first / event.rows) + 1;
        setPagination((prev) => ({
            ...prev,
            PageNumber: newPageNumber,
            PageSize: event.rows
        }));
    }, []);

    const handleApplyFilters = useCallback((newFilters) => {
        setFilters({
            startDate: newFilters.startDate,
            endDate: newFilters.endDate
        });
        setPagination((prev) => ({ ...prev, PageNumber: 1 }));
    }, []);

    const handleResetFilters = useCallback(() => {
        setFilters({
            startDate: getThreeMonthsAgo(),
            endDate: getToday()
        });
        setPagination((prev) => ({ ...prev, PageNumber: 1 }));
    }, []);

    return {
        rows,
        loading,
        totalCount,
        pagination,
        onPageChange,
        filters,
        handleApplyFilters,
        handleResetFilters,
        refetch
    };
};

export default useDealerStockAddData;
